<template>
    <div class="toolbox">
        <h4 class="container-title">
            My location
        </h4>
        <div v-if="markersSource === 'txCenters'">
            <div v-if="!selectedZip">
                <form action="#" @submit="submitZip" autocomplete="off">
                    <input type="hidden" autocomplete="false">
                    <p class="form-help">
                        Insert your ZIP Code to search transplant centers near you.
                    </p>
                    <input id="zip-search-panel-zip">
                    <button class="btn" type="submit">Search</button>
                </form>
            </div>
            <div v-else>
                Your ZIP Code is: <em>{{ selectedZip }}</em>
                <a class="btn" href="#" @click="clearSelectedZip">&times; Clear</a>
            </div>
            <!--
            <div class="collapsible-panel">
                <zip-insight-panel/>
            </div>
            -->
        </div>
        <div v-else>
            <p class="form-help">
                This feature is only available fot statistics regarding
                transplant centers. <em>{{ selectedStatistic.label }}</em> is
                calculated on data collected from hospitals.
            </p>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ZipInsightPanel from '../ZipInsightPanel'

export default {
  name: 'MyLocationPanel',
  components: {ZipInsightPanel},
  data: function () {
    return {
      geocoder: undefined,
      isCollapsed: true
    }
  },

  computed: {
    ...mapGetters({
      google: 'google',
      markersSource: 'markersSource',
      selectedStatistic: 'selectedStatistic',
      selectedZip: 'selectedZip',
      txCenters: 'txCenters'
    })
  },

  methods: {
    clearSelectedZip () {
      this.$store.commit('selectZip', null)
      this.$store.commit('setSelectedZipLatLng', null)
    },

    processGeocoderResults (zip, results) {
      let zipLatLng = results[0].geometry.location
      this.$store.commit('selectZip', zip)
      this.$store.commit('setSelectedZipLatLng', zipLatLng)

      // Get closest 5 Transplant Centers
      let fromLatLng = zipLatLng
      let google = this.google
      let txCenters = this.txCenters.map(function (txCenter) {
        let toLatLng = new google.maps.LatLng(txCenter.latLng)
        txCenter.distance = google.maps.geometry.spherical.computeDistanceBetween(fromLatLng, toLatLng)
        return txCenter
      })
      txCenters = txCenters
        .sort(function (a, b) { return a.distance - b.distance })
        .slice(0, 5)
      this.$store.commit('setSelectedZipClosestTxCenters', txCenters)
    },

    submitZip: function (event) {
      if (event) {
        event.preventDefault()
      }

      if (!this.geocoder) {
        this.geocoder = new this.google.maps.Geocoder()
      }

      var inputZip = document.getElementById('zip-search-panel-zip').value.trim()
      if (inputZip) {
        var zipSearchPanel = this
        this.geocoder.geocode({ 'address': 'US-' + inputZip }, function (results, status) {
          if (status === 'OK') {
            zipSearchPanel.processGeocoderResults(inputZip, results)
          } else {
            alert('Geocode was not successful for the following reason: ' + status)
          }
        })
      }
      return false
    }
  }
}
</script>

<style scoped>
.collapsible-panel {
    position: relative;
    margin: 0 -.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Toolboxes/MyLocationPanel.vue